const VALID_URL_PATTERN = /^(?:http(s)?:\/\/)?[\w.-]+(?:\.[\w.-]+)+[\w\-._~:/?#[\]@!$&'()*+,;=.%]+$/i;

export function getUrlParams(): Record<string, string> {
    const url = window.location.search;
    const urlParams = new URLSearchParams(url);
    const params = {};

    for (const key of urlParams.keys()) {
        const values = urlParams.getAll(key);
        params[key] = values.join();
    }

    return params;
}

export function isValidUrl(str = '') {
    return VALID_URL_PATTERN.test(str);
}

export function normalizeUrl(url = '', prefix = '') {
    const computedPrefix = prefix || `${window.location.protocol}//`;

    if (!/^https?:\/\//.test(url)) {
        return new URL(`${computedPrefix}//${url}`);
    }

    return new URL(url);
}
